import { render, staticRenderFns } from "./card-produtos-detalhe-data.vue?vue&type=template&id=5f0cc266&scoped=true"
import script from "./card-produtos-detalhe-data.vue?vue&type=script&lang=js"
export * from "./card-produtos-detalhe-data.vue?vue&type=script&lang=js"
import style0 from "./card-produtos-detalhe-data.vue?vue&type=style&index=0&id=5f0cc266&prod&lang=css"
import style1 from "./card-produtos-detalhe-data.vue?vue&type=style&index=1&id=5f0cc266&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0cc266",
  null
  
)

export default component.exports